<template>
  <wdw-dynbox :title="domainStore.translate('user.profile.menu-item.avatar')">
    <Form @submit="onSubmitEditAvatar">
      <div id="wdw-editavatar-form" class="wdw-form">
        <form-control-file
          :label="domainStore.translate('user.profile.avatar.form-label')"
          type="file"
          name="file"
          code="file"
          v-on:validate="onValidatedFormField"
          :serverError="data.errors['file']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          accepts="image/png,image/jpg,image/jpeg"
          parentFormId="wdw-editavatar-form"
          defaultvalue=""
        />
        <p />
        <button type="submit" class="btn btn-primary btn-form-submit" :disabled="data.loading" name="submit">
          {{ domainStore.translate('user.profile.avatar.submit') }}
        </button>
        &nbsp;
        <button
          type="button"
          class="btn btn-default btn-form-cancel"
          :disabled="data.loading"
          name="cancel"
          @click="emitClose()"
        >
          {{ domainStore.translate('user.form.cancel') }}
        </button>
        <vue-loading v-if="data.loading" />
      </div>
    </Form>
  </wdw-dynbox>
</template>

<script>
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';
import useConverter from '@/composables/general/useConverter';
import { onMounted, reactive, computed, ref } from 'vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';

import { Form } from 'vee-validate';
import VueLoading from '@/components/general/Loading';
import FormControlFile from '@/components/general/FormControl/File';

const UserRepository = RepositoryFactory.get('user');
const DomainRepository = RepositoryFactory.get('domain');

export default {
  name: 'change-avatar',

  props: {},
  emits: ['close'],

  setup(props, context) {
    const data = reactive({
      // Server-related errors
      errors: {},
      //show loading view
      loading: false,
      //file for avatar
      avatarFile: {},
    });
    const { toBool } = useConverter();
    const actionsMenu = ref(null);

    //+---------------------+
    //|   computed          |
    //+---------------------+

    const user = computed(() => {
      return userStore.getState().user;
    });

    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    //+--------------------+
    //|    Methods         |
    //+--------------------+

    function emitClose(message) {
      context.emit('close', message);
    }

    const onSubmitEditAvatar = (values, actions) => {
      data.loading = true;
      data.errors = [];

      const formdata = new FormData();
      formdata.append('avatarfile', data.avatarFile);
      UserRepository.putAvatar(user.value.id, formdata)
        .then(resp => {
          data.loading = false;
          userStore.fetchUser(true);
          emitClose(domainStore.translate('user.profile.avatar.success'));
        })
        .catch(err => {
          data.loading = false;
          data.errors['file'] = err.response.data.message;
        });
    };
    const onValidatedFormField = fieldValue => {
      if (fieldValue.type === 'file') {
        data.avatarFile = fieldValue['value'];
      }
    };

    return {
      // ---VARIABLE---
      domainStore,
      // Computed methods

      // Listeners
      onSubmitEditAvatar,
      onValidatedFormField,
      emitClose,

      // Other
      toBool,
      data,
    };
  },

  components: {
    WdwDynbox,
    VueLoading,
    Form,
    FormControlFile,
  },
};
</script>
